import { Container } from '@boltenergy-be/design-system'
import StartSimulationCard from 'components/start-simulation-card/StartSimulationCard'
import { SIMULATE_ID } from './StartSimulation.constants'
import styles from './StartSimulation.module.scss'
import { StartSimulationProps } from './types'

const StartSimulationSection = ({ containerClassName, fullWidth = true, ...simulationCardProps }: StartSimulationProps) => {
  return (
    <Container as="section" id={SIMULATE_ID} classnames={{ content: styles['simulation-card-wrapper'], container: containerClassName }}>
      <StartSimulationCard fullWidth={fullWidth} {...simulationCardProps} />
    </Container>
  )
}

export default StartSimulationSection
